export default () => document.querySelectorAll('[property="is_premium?"]')[0].content === 'true'
